import Qoasis from './Qoasis';

function App() {
  return <Qoasis />;
}

export default App;
